import React from "react";
import NavbarForlogin from "../navbarForlogin";
import Footer from  "../Footer";
import LoginBody from "../LoginBody";


export default function LoginPage(){

return(
<div>
<NavbarForlogin />
<LoginBody />
<Footer />
</div>

)

}